import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'partial/components/Button';
import Form, { ErrorLabel } from 'partial/form/Form';
import FormInput from 'partial/form/FormInput';
import { isUndefined } from 'lodash';
import { useCreateCategory, useUpdateCategory } from '../hooks';

function GenreModal({ closeModal, data }) {
  const isNew = isUndefined(data?.id);
  const [form, setForm] = useState(data);
  const [isCreating, create] = useCreateCategory();
  const [isUpdating, update] = useUpdateCategory();

  const handleSubmit = () => {
    if (isNew) {
      create(form, () => {
        closeModal();
      });
      return;
    }
    update(data?.id, form, () => {
      closeModal();
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className="mb-3">
        <FormInput
          name="name"
          onChange={setForm}
          value={form.name}
          label="Name"
          type="text"
          required
        />
        <ErrorLabel name="email" />
      </div>
      <div className="flex">
        <Button
          className="mr-2"
          onClick={closeModal}
          disabled={isCreating || isUpdating}
        >
          Close
        </Button>
        <Button primary type="submit" disabled={isCreating || isUpdating}>
          Save
        </Button>
      </div>
    </Form>
  );
}

GenreModal.defaultProps = {
  data: { name: '' },
};

GenreModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object),
};

export default GenreModal;
